import { render, staticRenderFns } from "./CadastroParecerReferencial.vue?vue&type=template&id=0d1c7a2c"
import script from "./CadastroParecerReferencial.vue?vue&type=script&setup=true&lang=ts"
export * from "./CadastroParecerReferencial.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports